<template>
  <div
    class="sidebar-wrapper-docs"
    :class="{ 'nav-open': $sidebar.showSidebar }"
  >
    <side-bar
      :background-color="sidebarBackground"
      short-title="We Are Soccer"
      title="We Are Soccer"
      logo="../assets/logo.png"
    >
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Dashboard',
            icon: 'ni ni-tv-2 text-black',
            path: '/dashboard'
          }"
          v-if="!isEditor"
        />
        <sidebar-item
          :link="{
            name: 'Schedule',
            icon: 'ni ni-spaceship text-black',
            path: '/schedule'
          }"
          v-if="isStreamer"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Live Stream',
            icon: 'ni ni-planet text-black',
            path: '/live_stream'
          }"
          v-if="isAdmin || isStreamer"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Club',
            icon: 'ni ni-world text-black',
            path: '/club'
          }"
          v-if="isAdmin"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'News Feed',
            icon: 'fa fa-rss text-black',
            path: '/newsfeed'
          }"
          v-if="isEditor || isAdmin"
        />
        <sidebar-item
          :link="{
            name: 'Notification',
            icon: 'ni ni-notification-70 text-black',
            path: '/notification'
          }"
          v-if="isAdmin"
        />
        <sidebar-item
          :link="{
            name: 'User Management',
            icon: 'ni ni-single-02 text-black',
            path: '/user_management'
          }"
          v-if="isStreamer || isAdmin"
        />
        <sidebar-item
          :link="{
            name: 'Configuration',
            icon: 'ni ni-settings text-black',
            path: '/configuration'
          }"
          v-if="isAdmin"
        />
      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <vue-progress-bar />
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
        <!-- <content-footer v-if="!$route.meta.hideFooter"></content-footer> -->
      </div>
    </div>
  </div>
</template>
<script>
import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import { FadeTransition } from "vue2-transitions";
import { mapGetters } from "vuex";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    FadeTransition
  },
  data() {
    return {
      sidebarBackground: "vue" // vue|blue|orange|green|red|primary
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  },
  computed: {
    ...mapGetters({
      isAdmin: "isAdmin",
      isEditor: "isEditor",
      isStreamer: "isStreamer"
    })
  }
};
</script>
<style lang="scss"></style>
